(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecom-sticky-cart"]) return;
  try {
    
  ;
  (function() {

// Handle Sticky cart
    const doc = window.document,
      $main_atc_forms = doc.querySelectorAll('form[action="/cart/add"]');
    var $main_atc_form = null;
    $main_atc_forms.length > 0 && $main_atc_forms.forEach(function($form) {
      if ($form.querySelector.querySelector('button[type=submit]')) {
        $main_atc_form = $form;
        return;
      }
    })
    if (! $main_atc_form) {
      return;
    }
    const $el_wrapper = doc.querySelector('.ecom-sticky__atc'),
      layout_simple = $el_wrapper.classList.contains('ecom-sticky-layout__simple'),
      main_atc_btn = $main_atc_form.querySelector('button[type=submit]'),
      sticky_atc_btn = $el_wrapper.querySelector('.ecom-sticky__atc--btn');;

    const handleVariantStickyCart = function() {

      const $el = doc.querySelector('.ecom-sticky__atc--variants');
      const $main_variant_wrapper = doc.querySelector('.ecom-product-single__variant-picker');

      if (! $main_variant_wrapper) 
        return;
      



      const selector = $main_variant_wrapper.querySelector('[name="id"]');
      const selector_id = selector.id;
      const sticky_selector_id = 'sticky-' + selector_id;
      let main_variant_html = null;

      if (! layout_simple) {
        main_variant_html = $main_variant_wrapper.querySelector('.ecom-product-single__variant-picker-wrapper').innerHTML;
      }

      if (! $el || ! $el_wrapper) 
        return;
      



      const json = $main_variant_wrapper.querySelector('#' + selector.dataset.jsonProduct);

      if (! json) {
        return;
      }
      if (! layout_simple) {
        main_variant_html = main_variant_html.replace(json.innerHTML, '');
      }

      let product = null;
      try {
        product = JSON.parse(json.innerHTML);
      } catch (e) {
        return;
      }

      if (main_variant_html) {
        let sticky_variant_html = main_variant_html.replaceAll(selector.id, sticky_selector_id);
        $el.innerHTML = sticky_variant_html;

// Handle swatch select
        let swatch_items = $el.querySelectorAll('.ecom-product-single__swatch-item[data-option-index]');
        if (swatch_items) {
          for (const swatch_item of swatch_items) {
            swatch_item.addEventListener('click', function(e) {
              e.preventDefault();

              const _this = this;

              if (_this.classList.contains('ecom-button-active ecom-image-button')) {
                return;
              }

              let siblings = getSiblings(_this);
              if (siblings) {
                for (const sibling of siblings) {
                  sibling.classList.remove('ecom-button-active', 'ecom-image-button');
                }
              }

              _this.classList.add('ecom-button-active', 'ecom-image-button');

              const index = _this.getAttribute('data-option-index');
              const select = $el.querySelector('select#' + sticky_selector_id + '-option-' + index);

              if (select) {
                select.value = _this.getAttribute('data-value');
                select.dispatchEvent(new Event('change'));
              }
            });
          }

// End handle click swatch event

// Handle select event
          let select_items = $el.querySelectorAll('.ecom-product-single__swatch-select');
          if (select_items) {
            for (select_item of select_items) {
              select_item.addEventListener('change', function(e) {
                e.preventDefault();
                const _this = this;
                const index = _this.getAttribute('data-option-index');
                const select = $el.querySelector('select#' + sticky_selector_id + '-option-' + index);

                if (select) {
                  select.value = _this.value;
                  select.dispatchEvent(new Event('change'));
                }
              });
            }
          } // End handle click swatch event
          const sticky_selector = $el.querySelector('[name="id"]');
          let select_wrappers = $el.querySelectorAll('.selector-wrapper').forEach(function(el) {
            el.remove();
          })
          const mySelector = new window.EComposer.OptionSelectors(sticky_selector.id, {
            product: product,
            onVariantSelected: selectCallback,
            enableHistoryState: true
          });

          function selectCallback(variant) {
            if (parseInt(selector.value) != parseInt(variant.id)) {
              selector.value = variant.id;
              selector.dispatchEvent(new Event('swatch'));
            }
            updateSwatch(variant);
            updateOptionSelected(variant);
            updateImage(variant);
            updatePrice(variant);
            updateProductButtons(variant);
          }

// Trigger when main form change value
          selector.addEventListener('change', function(event) {
            if (parseInt(sticky_selector.value) !== parseInt(event.target.value)) 
              mySelector.selectVariant(event.target.value);
            



          });

// Update label
          function updateOptionSelected(variant) {
            const $container = $el.querySelector('.ecom-product-single__variant-picker-container');
            if (! $container || ! variant) {
              return false;
            }

            $container.querySelectorAll('.ecom-product-single__variant-picker--selected-value').forEach(function(el) {
              el.remove();
            });

            const length = variant.options.length;
            const $doms = $container.querySelectorAll('.selector-wrapper');

            for (let i = 0; i < length; i++) {
              const newLabelDom = document.createElement('span');
              newLabelDom.className = 'ecom-product-single__variant-picker--selected-value';
              newLabelDom.innerText = ': ' + variant.options[i]

              let label = $doms[i].querySelector(`label`);
              if (label) 
                label.append(newLabelDom);
              



              let select_option = $container.querySelector(`select.ecom-product-single__swatch-select[data-option-index="${i}"]`);
              if (select_option) 
                select_option.value = variant.options[i];
              



            }
          }
        }
      } else {
        const selector_sticky = $el_wrapper.querySelector('select[name=id]');
        if (! selector_sticky) 
          return;
        



        selector_sticky.addEventListener('change', function(e) {
          handleSimpleVariantChange();
        })
        handleSimpleVariantChange();

        function handleSimpleVariantChange() {
          let selected_index = selector_sticky.options[selector_sticky.selectedIndex];
          if (! selected_index) 
            return;
          



          let variant_id = selected_index.value;
          if (variant_id) {
            let variant = product.variants.find(variant => variant.id == variant_id);
            if (variant) {
              if (parseInt(selector.value) != parseInt(variant.id)) {
                selector.value = variant.id;
                selector.dispatchEvent(new Event('swatch'));
              }
              updateImage(variant);
              updatePrice(variant);
              updateProductButtons(variant);
            }
          }
        }
        selector.addEventListener('change', function(event) {
          if (parseInt(selector_sticky.value) !== parseInt(event.target.value)) 
            selector_sticky.value = event.target.value;
          



          selector_sticky.dispatchEvent(new Event('change'));
        });
      }

// Update thumbail image
      function updateImage(variant) {
        const $section = doc.querySelector('.ecom-sticky__atc');
        const image_wrapper = $section.querySelector('.ecom-sticky__atc--image');
        const image = $section.querySelector('.ecom-sticky__atc--image img');
        const image_size = $el_wrapper.getAttribute('data-img-size') || '100x';
        if (image && variant.featured_image != null) {
          let image_src = window.EComposer.resizeImage(variant.featured_image.src, image_size);
          image_wrapper.classList.add('ecom-loading-image');
          image.setAttribute('src', image_src);

          image.onload = function() {
            image_wrapper.classList.remove('ecom-loading-image');
          }
        }
      }

// Update price
      function updatePrice(variant) {
        const $section = doc.querySelector('.ecom-sticky__atc'),
          $price = $section.querySelector('.ecom-sticky__atc--price');

        if (variant) {
          const variant_price_sale = variant.compare_at_price != null
              ? variant.compare_at_price
              : variant.price,
            variant_price_regular = variant.price;

          if (variant_price_sale > variant_price_regular) {
            $price.innerHTML = `<del>${
              window.EComposer.formatMoney(variant_price_sale)
            }</del><ins>${
              window.EComposer.formatMoney(variant.price)
            }</ins>`;
          } else {
            $price.innerHTML = window.EComposer.formatMoney(variant.price);
          }
        }
      }

      function updateSwatch(variant) {
        if (variant && variant.options.length) {
          const $section = doc.querySelector('.ecom-sticky__atc');
          for (let i = 0; i < variant.options.length; i++) {
            $section.querySelectorAll(`.ecom-product-single__swatch-item[data-option-index="${i}"][data-value="${
              variant.options[i].replace(/'/g, '\'').replace(/"/g, '&quot;')
            }"]`).forEach((element) => {
              element.parentNode.childNodes.forEach(function(el) {
                if (el.classList) {
                  el.classList.remove('ecom-box-active');
                  el.classList.remove('ecom-button-active');
                  el.classList.remove('ecom-image-active');
                }
              });
              element.classList.add('ecom-box-active');
              element.classList.add('ecom-button-active');
              element.classList.add('ecom-image-active');
            });
            $section.querySelectorAll(`select.ecom-product-single__swatch-select[data-option-index="${i}"]`).forEach(function(el) {
              el.value = variant.options[i];
            })
          }
        }
      }

// Update button
      function updateProductButtons(variant) {
        if (sticky_atc_btn) {
          if (! variant || ! variant.available) {
            sticky_atc_btn.setAttribute('disabled', 'disabled');
            ecomStickyATCText();
          } else if (variant.available) {
            sticky_atc_btn.removeAttribute('disabled');
            ecomStickyATCText();
          } else {
            sticky_atc_btn.setAttribute('disabled', 'disabled');
            ecomStickyATCText();
          }
        }
      }
      let getSiblings = function(e) {

// for collecting siblings
        let siblings = [];

// if no parent, return no sibling
        if (! e.parentNode) {
          return siblings;
        }

// first child of the parent node
        let sibling = e.parentNode.firstChild;

// collecting siblings
        while (sibling) {
          if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling);
          }
          sibling = sibling.nextSibling;
        }
        return siblings;
      };
    };

    const handleSimpleVariant = function() {
      const selector = $el_wrapper.querySelector('select[name=ecom-sticky-cart__select]');
      if (! selector) 
        return;
      



      selector.addEventListener('change', function(e) {
        let selected_index = selector.options[selector.selectedIndex];
        if (! selected_index) 
          return;
        



        const $main_variant_wrapper = doc.querySelector('.ecom-product-single__variant-picker');
        if (! $main_variant_wrapper) 
          return;
        



        const selector = $main_variant_wrapper.querySelector('[name="id"]');

        let price = selected_index.getAttribute('data-price'),
          compare_at_price = selected_index.getAttribute('data-compare-price') || 0,
          image = selected_index.getAttribute('data-image'),
          available = selected_index.getAttribute('data-available'),
          product_id = selected_index.value;

// Update image
        let item_image = $el_wrapper.querySelector('.ecom-sticky__atc--image');
        if (item_image) {
          item_image.classList.add('ecom-loading-image');
          item_image.querySelector('img').setAttribute('src', image);
          item_image.querySelector('img').onload = () => {
            item_image.classList.remove('ecom-loading-image');
          }
        }

// Update price
        const $price = $el_wrapper.querySelector('.ecom-sticky__atc--price');
        if (price < compare_at_price) {
          $price.innerHTML = `<del>${
            window.EComposer.formatMoney(compare_at_price)
          }</del><ins>${
            window.EComposer.formatMoney(price)
          }</ins>`;
        } else {
          $price.innerHTML = window.EComposer.formatMoney(price);
        }

      })
    }
    const handleQuantity = function() {

// Handle quantity
      const btn_qty_plus = $el_wrapper.querySelector('.ecom-plus');
      const btn_qty_minus = $el_wrapper.querySelector('.ecom-minus');
      const qty_input = $el_wrapper.querySelector('.ecom-qty-input');
      var main_qty_input = $main_atc_form.querySelector('.ecom-product-single__quantity-input');

      if (! main_qty_input) {
        main_qty_input = document.createElement('input');
        main_qty_input.type = 'number';
        main_qty_input.style.display = 'none';
        main_qty_input.name = 'quantity';
        main_qty_input.value = 1;
        $main_atc_form.appendChild(main_qty_input);
      }

      qty_input.addEventListener('change', function(e) {
        const value = this.value;
        if (main_qty_input != value) 
          main_qty_input.value = value;
        



      })
      main_qty_input.addEventListener('change', function(e) {
        const value = this.value;
        if (main_qty_input != value) 
          qty_input.value = value;
        



      })

      if (btn_qty_plus) {
        btn_qty_plus.addEventListener('click', function(e) {
          e.preventDefault();
          changeQty('plus');
        })
      }
      if (btn_qty_minus) {
        btn_qty_minus.addEventListener('click', function(e) {
          e.preventDefault();
          changeQty('minus');
        })
      }

      const changeQty = function(type) {

        let currentVal = parseFloat(qty_input.value),
          max = parseFloat(qty_input.getAttribute('max')),
          min = parseFloat(qty_input.getAttribute('min')),
          step = qty_input.getAttribute('step');

// Format values
        if (! currentVal || currentVal === '' || currentVal === 'NaN') 
          currentVal = 0;
        



        if (max === '' || max === 'NaN') 
          max = '';
        



        if (min === '' || min === 'NaN') 
          min = 0;
        



        if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') 
          step = 1;
        



        if (type == 'plus') {
          if (max && (currentVal >= max)) {
            qty_input.value = max;
          } else {
            qty_input.value = (currentVal + parseFloat(step)).toFixed();
            if (main_qty_input) 
              main_qty_input.value = (currentVal + parseFloat(step)).toFixed();
            



          }
        } else {
          if (min && (currentVal <= min)) {
            qty_input.value = min;
          } else if (currentVal > 0) {
            qty_input.value = (currentVal - parseFloat(step)).toFixed();
            if (main_qty_input) 
              main_qty_input.value = (currentVal - parseFloat(step)).toFixed();
            



          }
        }
      }
    }

    const handleATC = function() {

// Handle Addtocart
      if (sticky_atc_btn) {
        sticky_atc_btn.addEventListener('click', function(e) {
          e.preventDefault();
          let _this = this;
          _this.classList.add('ecom-loading');
          if (main_atc_btn) {
            main_atc_btn.click();
          }

          setTimeout(function() {
            _this.classList.remove('ecom-loading');
          }, 500)
        });
      }
    }

    const ecomStickyCart = function() {
      const $sticky_wrapper = doc.querySelector('.ecom-sticky__atc');
      const main_btn_submit = $main_atc_form.querySelector('button[type=submit]');

      if (! $sticky_wrapper) 
        return;
      



      if ($sticky_wrapper && main_btn_submit) {
        let summaryOffset = window.scrollY + main_btn_submit.getBoundingClientRect().top + main_btn_submit.offsetHeight;

        var stickyAddToCartToggle = function() {
          var windowScroll = window.pageYOffset || document.documentElement.scrollTop,
            windowHeight = window.innerHeight,
            documentHeight = document.body.clientHeight,
            totalScroll = parseInt(windowScroll + windowHeight) + 60;

          if (summaryOffset < windowScroll && totalScroll !== documentHeight && totalScroll < documentHeight) {
            $sticky_wrapper.classList.add('ecom-sticky-show');
          } else if (totalScroll === documentHeight || totalScroll > documentHeight || summaryOffset > windowScroll) {
            $sticky_wrapper.classList.remove('ecom-sticky-show');
          }
        };

        stickyAddToCartToggle();
        window.addEventListener('scroll', stickyAddToCartToggle);
      }
    }

    const ecomStickyStyle = function() {
      const qty = $el_wrapper.querySelector('.ecom-sticky__atc--quantity');

// if (main_atc_btn && sticky_atc_btn) {
// let btn_style = getComputedStyle(main_atc_btn);
// sticky_atc_btn.style.backgroundColor = btn_style.backgroundColor;
// sticky_atc_btn.style.color = btn_style.color;
// sticky_atc_btn.style.textTransform = btn_style.textTransform;
// }

      const swatch_color_main = $main_atc_form.querySelector('.ecom-product-single__picker-colors-item');
      const swatch_color_sticky = $el_wrapper.querySelectorAll('.ecom-product-single__picker-colors-item');

      if (swatch_color_main && swatch_color_sticky) {

        let btn_style = getComputedStyle(swatch_color_main);
        swatch_color_sticky.forEach(function(el) {
          el.style.borderRadius = btn_style.borderRadius;
        })
      }

      const swatch_select_main = $main_atc_form.querySelector('.ecom-product-single__picker-dropdown-list');
      const swatch_select_sticky = $el_wrapper.querySelectorAll('.ecom-product-single__picker-dropdown-list');

      if (swatch_select_main && swatch_select_sticky) {

        let btn_style = getComputedStyle(swatch_select_main);
        swatch_select_sticky.forEach(function(el) {
          el.style.borderRadius = btn_style.borderRadius;
        })
      }

    }

    const ecomStickyATCText = function() {
      if (main_atc_btn && sticky_atc_btn) {
        let atc_text = main_atc_btn && main_atc_btn.dataset.textAddCart
            ? main_atc_btn.dataset.textAddCart
            : '',
          outstock_text = main_atc_btn && main_atc_btn.dataset.textOutstock
            ? main_atc_btn.dataset.textOutstock
            : '';
        if (sticky_atc_btn.hasAttribute('disabled')) {
          sticky_atc_btn.querySelector('.ecom-add-to-cart-text').innerText = outstock_text;
        } else {
          sticky_atc_btn.querySelector('.ecom-add-to-cart-text').innerText = atc_text;
        }
      }
    }

// Listen for `DOMContentLoaded` event
    document.addEventListener('DOMContentLoaded', function(e) {
      handleVariantStickyCart();
      handleQuantity();
      handleATC();
      ecomStickyCart();
      ecomStickyStyle();
      ecomStickyATCText()
    });

  })()

  } catch(e) { console.error(e); }
})();
})();
